/** Mirrors the backend's `@vv/requests-backend` enums - duplicated here since
 * the frontend and backend are separate workspaces/deployments. */
export enum RequestStatus {
  Submitted = "Submitted",
  Assigned = "Assigned",
  Rejected = "Rejected",
  InProgress = "InProgress",
  Completed = "Completed",
  ReworkRequired = "ReworkRequired",
}

export const ALL_REQUEST_STATUSES: RequestStatus[] = Object.values(RequestStatus);

export const REQUEST_STATUS_LABELS: Record<RequestStatus, string> = {
  [RequestStatus.Submitted]: "Submitted",
  [RequestStatus.Assigned]: "Assigned",
  [RequestStatus.Rejected]: "Rejected",
  [RequestStatus.InProgress]: "In Progress",
  [RequestStatus.Completed]: "Completed",
  [RequestStatus.ReworkRequired]: "Rework Required",
};

export enum Priority {
  Critical = "Critical",
  High = "High",
  Medium = "Medium",
  Low = "Low",
}

export const ALL_PRIORITIES: Priority[] = Object.values(Priority);

export enum ValidationResult {
  Pass = "Pass",
  Fail = "Fail",
  ConditionalPass = "ConditionalPass",
  Inconclusive = "Inconclusive",
}

export const ALL_VALIDATION_RESULTS: ValidationResult[] = Object.values(ValidationResult);

export const VALIDATION_RESULT_LABELS: Record<ValidationResult, string> = {
  [ValidationResult.Pass]: "Pass",
  [ValidationResult.Fail]: "Fail",
  [ValidationResult.ConditionalPass]: "Conditional Pass",
  [ValidationResult.Inconclusive]: "Inconclusive",
};

export interface AnalyticsSummary {
  totalRequests: number;
  byStatus: Record<RequestStatus, number>;
  byPriority: Record<Priority, number>;
  byValidationResult: Record<ValidationResult, number>;
  onTimeCompletions: number;
  lateCompletions: number;
  averageCompletionDays: number | null;
}

export interface TeamAnalytics {
  teamId: string;
  teamName: string;
  totalRequests: number;
  openRequests: number;
  closedRequests: number;
}
